import type { ReactElement } from 'react';

import { ArrowRightOutlined } from '@ant-design/icons';
import { Card } from 'antd';
import cn from 'classnames';

import styles from './StatCard.module.scss';

interface IProp {
  className?: string;
  theme: 'green' | 'yellow' | 'red';
  icon: ReactElement;
  title: string;
  value: number;
  steps: string[];
}

export const StatCard = ({ className, theme, icon, title, value, steps }: IProp) => (
  <Card className={cn(styles[`wrapper-${theme}`], className)}>
    <div className={styles['header-wrapper']}>
      <span className={styles.icon}>{icon}</span>
      <p className={styles.title}>{title}</p>
    </div>
    <p className={styles.value}>{value}</p>
    <div className={styles['steps-wrapper']}>
      {steps.map((step, index) => (
        <div
          key={step}
          className={styles.step}
        >
          {index !== steps.length && <ArrowRightOutlined className={styles['step-icon']} />}
          <p className={styles['step-description']}>{step}</p>
        </div>
      ))}
    </div>
  </Card>
);
